import http from 'hub-http/clients/apiClient';
import { handleError } from '../utils/errorHandling';
export const VALID_CURRENCY_ENDPOINT = 'payments/v1/limits/portal-currencies';

//API docs: https://tools.hubteam.com/api-catalog/services/PaymentsService/v1/spec/internal#operations-Limits-get-%2Fpayments%2Fv1%2Flimits%2Fportal-currencies
export const fetchValidCurrencies = () => http.get(VALID_CURRENCY_ENDPOINT).catch(err => {
  throw handleError(err);
});